import { useMemo } from "react";
import { createApi, type EnvName } from "./api";

/** Stable API client per env — createApi() returns a new object every call. */
export function useApi(env: EnvName) {
  return useMemo(() => createApi(env), [env]);
}
